import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSupportDialogBox } from '~/components/support/ducks/index.js';
import { NotificationCard, Spacer } from '@comeon/ui';
import Icon, { ICON_WARNING_LINE } from '~/components/icon/index.js';
import { hideBinaryNotification } from '../../notifications/ducks/notifications';
import { useRouter } from '~/utils/navigation';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';
import { ROUTE_RESET_PASSWORD } from '~/components/router/constants';

export const FORM_NOTIFICATION_ERROR_CODES = [
	'PLAYER_NOT_AUTHENTICATED',
	'PLAYER_EXCEPTION_USERNAME_AND_OR_PASSWORD_IS_WRONG',
	'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_4',
	'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_3',
	'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_2',
	'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_1'
];

const FormNotification = ({ translations }) => {
	const { popupMessageData = {} } = useSelector(state => state.notifications);
	const dispatch = useDispatch();
	const router = useRouter();
	const transformPath = useContextualPathTransformer();

	const [data, setData] = useState({
		message: '',
		open: false,
		buttonCallback: null,
		buttonText: ''
	});

	const openCustomerSupport = useCallback(() => {
		dispatch(showSupportDialogBox(true));
		dispatch(hideBinaryNotification());
	}, [dispatch]);

	const goToForgotPasswordFlow = useCallback(() => {
		router.push(transformPath(ROUTE_RESET_PASSWORD));
		dispatch(hideBinaryNotification());
	}, [dispatch, router, transformPath]);

	useEffect(() => {
		if (FORM_NOTIFICATION_ERROR_CODES.includes(popupMessageData.errorCode)) {
			switch (popupMessageData.errorCode) {
				case 'PLAYER_NOT_AUTHENTICATED':
				case 'PLAYER_EXCEPTION_USERNAME_AND_OR_PASSWORD_IS_WRONG':
					setData({
						message: popupMessageData.errorDescription,
						open: true,
						buttonCallback: openCustomerSupport,
						buttonText: translations.BUTTON_CUSTOMER_SUPPORT
					});
					break;
				case 'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_4':
				case 'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_3':
				case 'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_2':
				case 'USERNAME_AND_OR_PASSWORD_IS_WRONG_ATTEMPT_1':
					setData({
						message: popupMessageData.errorDescription,
						open: true,
						buttonCallback: goToForgotPasswordFlow,
						buttonText: translations.FORGOT_PASSWORD
					});
					break;
				default:
					setData({
						message: '',
						open: false,
						buttonCallback: null,
						buttonText: ''
					});
					break;
			}
		} else {
			setData({
				message: '',
				open: false,
				buttonCallback: null,
				buttonText: ''
			});
		}
	}, [
		goToForgotPasswordFlow,
		openCustomerSupport,
		popupMessageData,
		translations.BUTTON_CUSTOMER_SUPPORT,
		translations.FORGOT_PASSWORD
	]);

	return (
		<>
			<NotificationCard
				dataAt="login-form-notification"
				message={data.message}
				buttonText={data.buttonText}
				Icon={<Icon type={ICON_WARNING_LINE} width={40} height={35.5} />}
				buttonCallback={data.buttonCallback}
				open={data.open}
				className="login-form-notification"
			/>
			{data.open && <Spacer />}
		</>
	);
};

export default FormNotification;
